import React from 'react';
import { IoMdClose } from 'react-icons/io';
import Manager from './Manager';
import { ModalCloseBtn, ModalHeaderStyled } from '@styled/Modal';
export default function ModalHeader(_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b;
    return (React.createElement(ModalHeaderStyled, null,
        React.createElement("span", { "aria-hidden": "true" }, title),
        React.createElement(ModalCloseBtn, { type: "button", onClick: Manager.closeModal, "aria-label": "Close" },
            React.createElement(IoMdClose, null))));
}
